import { z } from 'zod'

export const clientESignRequestSchema = z.object({
  signatureBase64: z.string(),
})

export type TClientESignRequest = z.infer<typeof clientESignRequestSchema>

export const clientESignSchema = z
  .object({
    id: z.number(),
    signatureBase64: z.string(),
  })
  .nullable()

export type TClientESign = z.infer<typeof clientESignSchema>
